
import fileImg from '../assets/img/icon/genericfile.svg'
import file_ppt from '../assets/img/icon/pptx.svg'
import file_excel from '../assets/img/icon/xlsx.svg'



export const tableTitle ={
        img : fileImg,
        name : "이름",
        size : "용량",
        date : "수정된 날짜",
        person : "수정한 사람",
    }

export const tableContents =[
    {
        img : file_ppt,
        name : "111Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    },
    {
        img : file_excel,
        name : "222Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis modi minus neque repellat veritatis. Reiciendis, repellendus cumque aspernatur, numquam sit esse nisi quae voluptatum iusto distinctio sequi obcaecati aliquid assumenda.",
        size : "333.33KB",
        date : "8월 24일",
        person : "신진철"
    }
];   
